<template>
<inertia-head title="Integrity Policy" />

<div>
    <breadcrumb>
        <breadcrumb-item>
            <inertia-link href="/">Hem</inertia-link>
        </breadcrumb-item>
        <breadcrumb-item :last="true">
            {{ $t('integrity-policy') }}
        </breadcrumb-item>
    </breadcrumb>

    <div class="main container page-content-padding">
        <h1 class="page-heading text-red">{{ $t('integrity-policy') }}</h1>

        <div class="mt-4 underline">Senast uppdaterad: 2022-03-16</div>

        <p class="text-light-w justify-content subtitle-padding">
            Vi på Familjekortet är måna om att värna och respektera integriteten för de personer som är
            medlemmar hos oss, samt de företag och dess privata företrädare som interagerar med oss.
        </p>
        <h4 class="subtitle subtitle-padding">Vi behandlar personuppgifter av flera skäl:</h4>
        <p class="text-light-w justify-content">
            <ul class="text-light-w">
                <li>För att förbättra användarupplevelsen kring våra tjänster och våra digitala kanaler, samt för att
                    kunna besvara förfrågningar till vår kundservice</li>
                <li>I syfte att uppfylla våra skyldigheter enligt lagar, myndighetsföreskrifter och förordningar</li>
                <li>För att effektivt kunna genomföra kreditbedömningsprocesser (företag)</li>
                <li>Kartläggning av insamlad data för att skapa en förståelse för marknadstrender i syfte att
                    utveckla och förbättra vår marknadsföring och våra tjänster</li>
            </ul>
        </p>
        <h4 class="subtitle subtitle-padding">Insamlingen av personuppgifter sker vid olika tillfällen:</h4>
        <span class="text-light-w justify-content">
            Gällande digitala kanaler kan det
            exempelvis ske när personen begär att bli kontaktad, registrerar sig för nyhetsbrev, eller
            kontaktar Familjekortet via e-post. Familjekortet kan även komma att samla in personuppgifter via
            andra ej digitala kanaler, exempelvis under telefonsamtal eller fysiska möten. Vidare kan
            Familjekortet komma att samla in personuppgifter från marknadsförings partners, publika
            databaser, sociala medier, kreditupplysningsföretag och andra samarbetspartners.
        </span>
        <h4 class="subtitle subtitle-padding">Personuppgifter som Familjekortet samlar in från företag: </h4>
        <span class="text-light-w justify-content">
            Familjekortet samlar in den information som lämnas vid och kring ordertillfället. I samband med detta samlas följande
            kategorier av personuppgifter in: Namn, adress, telefonnummer, e-post, personnummer och/eller
            organisationsnummer, eventuella betalningsanmärkningar och skuldsaldo hos
            Kronofogdemyndigheten, samt eventuell annan finansiell information kring företag och dess
            företrädare.
        </span>
        <h4 class="subtitle subtitle-padding">Personuppgifter som Familjekortet samlar in från privatpersoner (medlemmar):</h4>
        <p class="text-light-w justify-content">
            Familjekortet samlar in den information som lämnas vid registrering av medlemskap, eller vid
            senare tillfälle på Mina sidor. Detta kan till exempel vara personnummer, adress, e-post,
            telefonnummer, personnummer, namn på barn och deras personnummer.
        </p>
        <h4 class="subtitle subtitle-padding">Användning av insamlade personuppgifter:</h4>
        <p class="text-light-w justify-content">
            Familjekortet använder personuppgifterna för intern administration, fullgörande av avtal,
            marknadsföringssyften, säkerhetsändamål, förbättringsåtgärder och för att svara på kunders
            frågor och önskemål, fastställande av identitet, kundkännedomskontroller, kreditbedömningar
            (företag).
        </p>
        <h4 class="subtitle subtitle-padding">För att kunna marknadsföra oss mot dig </h4>
        <p class="text-light-w justify-content">
            och visa våra produkter och erbjudanden både på vår
            sajt och genom samarbetspartners, hanterar vi de här uppgifterna om dig:
             <ul class="text-light-w">
                 <li>IP-adresser</li>
                 <li>Data som samlats in ifrån cookies och liknande, exempelvis vilka erbjudanden och
                    företag du klickat på, sidor du har besökt och om du kommit till vår sajt via exempelvis en
                    annons</li>
             </ul>
            För att göra detta använder vi oss av olika externa annonstjänster och samarbetspartners.
        </p>
        <h4 class="subtitle subtitle-padding">För att kunna erbjuda dig en personifierad sajt</h4>
        <p class="text-light-w justify-content">
            som ger dig bästa möjliga upplevelse och ger dig mer relevanta visningar och rekommendationer, behandlar vi de här uppgifterna om dig:
            <ul class="text-light-w">
                 <li>IP-adresser</li>
                 <li>Data som samlats in ifrån cookies och liknande, exempelvis vilka erbjudanden och
                    företag som du klickat på och din historik gällande utnyttjande av erbjudanden</li>
            </ul>

            <p>Vi vill himlans gärna bli bättre, och bättre på att förstå hur de som besöker vår sajt använder den och för att göra detta så använder vi en tjänst som anonymt samlar in information om beteenden som besökaren har. Detta är t.ex. musklick och hur länge ett besök varar. Denna infon använder vi sedan för att kunna utveckla och anpassa sajten så att upplevelsen för våra besökare blir ännu bättre. Tjänsten samlar endast in beteendet på denna webbplats. Informationen som samlas in lagras på servrar i Irland. Om du önskar att inte lämna information till denna tjänsten, så kan du spärra cookies i din webbläsare, eller besöka: <a href="https://www.hotjar.com/legal/compliance/opt-out" target="_blank" class="underline">https://www.hotjar.com/legal/compliance/opt-out</a></p>

            Den här datan analyserar vi och ger dig sedan förslag på andra erbjudanden eller företag du
            kanske skulle tycka om på vår sajt. Detta gör vi med ditt samtycke som du ger i cookie-bannern
            på vår sajt. Om du vill kan du rensa din cookiedata, vilket tar bort all historik.
        </p>
        <h4 class="subtitle subtitle-padding">Skydd av personuppgifter</h4>
        <p class="text-light-w justify-content">
            Familjekortet genomför löpande organisatoriska, tekniska och administrativa åtgärder i syfte att
            skydda personuppgifter från otillbörlig åtkomst, förstörelse eller förändring. Har du anledning att
            misstänka att interaktionen med Familjekortet inte är säker, kontakta oss omgående.
        </p>
        <h4 class="subtitle subtitle-padding">Tid för lagring av personuppgifter</h4>
        <p class="text-light-w justify-content">
            Familjekortet behåller och sparar endast personuppgifter under den tid det är nödvändigt för att
            uppfylla ändamålen beskrivna i denna integritetspolicy samt för uppfyllelse av Familjekortets
            skyldigheter enligt lagstiftning. Vid den tidpunkt då uppgifterna saknar relevans enligt ovan
            kommer de att raderas alternativt anonymiseras.
        </p>
        <h4 class="subtitle subtitle-padding">Delning av persondata till tredje part</h4>
        <p class="text-light-w justify-content">
            Familjekortet delar inte personuppgifter till tredje part, med följande undantag: Till
            samarbetspartner för marknadsföringsåtgärder; till kreditupplysningsföretag (gäller Företag); till
            leverantörer vid relevans att kunna tillhandahålla tjänster (exempelvis IT-system); vid eventuell
            försäljning av hela eller delar av Familjekortets verksamhet, eller vid fall där tredje part övertar
            låneavtal eller andra fordringar.
        </p>
        <h4 class="subtitle subtitle-padding">Rättslig grund</h4>
        <p class="text-light-w justify-content">
            Rättslig grund för behandlingen av personuppgifter baserar sig på att
            personuppgiftsbehandlingen är nödvändig för fullgörande av en rättslig förpliktelse enligt tillämplig
            lagstiftning, exempelvis bokföringslagen eller att personuppgiftsbehandlingen är nödvändig för att
            fullgöra avtalet mellan Familjekortet och avtalspart.
        </p>
        <h4 class="subtitle subtitle-padding">Rättigheter</h4>
        <p class="text-light-w justify-content">
            En privatperson, ett företag eller dess företrädare har rätt att invända mot behandling av
            personuppgifter i marknadsföringssyfte. Invändningar sker genom kontakt till Familjekortet per
            e-post eller post enligt nedan kontaktuppgifter. Rättigheter innefattar även rätten att begära
            tillgång till personuppgifter, begära rättelse eller radering/begränsning av behandlingen av
            personuppgifter. Du har också rätt att lämna in eventuella klagomål gällande Familjekortets
            behandling av dina personuppgifter till behörig tillsynsmyndighet; Datainspektionen.
        </p>
        <h4 class="subtitle subtitle-padding">Begränsning av integritetspolicyn</h4>
        <p class="text-light-w justify-content">
           Integritetspolicyn omfattar inte hantering av personuppgifter via tredjepart som Familjekortet inte
           äger eller kontrollerar eller för personer som inte har ett avtal med, eller är anställda, av
           Familjekortet.
        </p>
        <h4 class="subtitle subtitle-padding">Kontaktuppgifter</h4>
        <p class="text-light-w justify-content container-padding">
            Familjekortet värnar om din integritet och du är välkommen att kontakta oss vid frågor eller
            eventuella klagomål kring insamling och användning av personuppgifter via post till: Familjekortet
            Sverige AB, Österlånggatan 69, 503 37 Borås eller via vårt <inertia-link href="/kontakta-oss">kontaktformulär</inertia-link>.
        </p>
    </div>
    <inertia-link class="btn btn-danger cookies-button " href="/kampanjer">{{ $t('all_discounts') }}</inertia-link>
    </div>
</template>
